import React, { useContext } from 'react';
import { AppContext } from './AppContext';
import { useNavigate } from 'react-router-dom';
import Dot from './assets/dot.png';
import { getAuth, signOut } from 'firebase/auth';

const bottomAreaHeight = '18vh';
const horizontalAreaSpacing = '1.5vh';
const scrollAreaTopPadding = '18vh';
const imageSize = '2vh';







const CategoriesScreen2 = ({ onLogout }) => {
  const { userId2, setMyPosts, showMediaPopup, following, setCurrentlyLoadingProfile, currentUser, setViewingProfile, setActivePopupMedia, activePopupMedia,
    setUserWallet, setCurrentUser
   } = useContext(AppContext);
  const navigate = useNavigate();

  const specialUserIds = [
    "h0fEIStkM4XHTDErZM5i8XIo9rA3",
    "OHaY20b54nTGd5BBgbJOL2BHEbX2",
    "rdX289s3YBP31Hw5qn2eXVywtBq1",
    "Mkf4631LCEOYmHXWRzGirPdxBrt1"
  ];
  
  const isFan = currentUser?.accountType === 'Fan';

  const categories = specialUserIds.includes(userId2) ? [
    { name: 'Logout', route: 'logout' },
    { name: 'Edit Login', route: 'password' },
    { name: 'Personal Information', route: 'PersonalInfo' },
    { name: 'Report', route: 'Report' },
    { name: 'Support', route: 'Support' },
    { name: 'Terms Of Service', route: 'Terms' },
    ...(isFan ? [] : [{ name: 'Review and Delete', route: 'RemoveReleases' }]),
    { name: 'Delete Account', route: 'DeactivateAccount' },
  ] : [
    { name: 'Logout', route: 'logout' },
    { name: 'Edit Login', route: 'password' },
    { name: 'Personal Information', route: 'PersonalInfo' },
    { name: 'Report', route: 'Report' },
    { name: 'Support', route: 'Support' },
    { name: 'Terms Of Service', route: 'Terms' },
    ...(isFan ? [] : [{ name: 'Review and Delete', route: 'RemoveReleases' }]),
    { name: 'Delete Account', route: 'DeactivateAccount' },
  ];
  



  const handlePress = (category) => {
     // Log the category being navigated to
    if (category === 'logout') {
      const auth = getAuth();
      signOut(auth)
        .then(() => { 
        setMyPosts([]);
          navigate('/login');
        })
        .catch((error) => {
          console.error("Error signing out:", error);
        });
        setUserWallet([]);
        setCurrentUser([]);
    } else {
      const path = `/mydat/settings/${category.toLowerCase()}`;
       // Log the navigation path
      navigate(path);
    }
  };
  
  
  
   

  return (
    <div style={styles.fullScreen}>
      <div style={styles.headerContainer}>
        <h2 style={styles.headerText}>Settings</h2>
      </div>
      <div style={styles.container}>
        <ul style={styles.scrollContainer}>
          {categories.map((item) => (
            <li key={item.route} style={styles.listItem}>
              <button onClick={() => handlePress(item.route)} style={styles.button}>
                <div style={styles.row}>
                  <img
                    src={Dot}
                    alt="Dot"
                    style={{ width: imageSize, height: imageSize, marginRight: '1vw' }}
                  />
                  <span style={styles.text}>{item.name}</span>
                </div>
              </button>
              <div style={styles.borderContainer}>
                <div style={styles.centeredBorder}></div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const styles = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    zIndex: 10,
    height: `calc(100vh - ${bottomAreaHeight})`,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fullScreen: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    alignItems: 'center', // Center the header horizontally
  },
  button: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '1vh',
    margin: '1vh 0',
    cursor: 'pointer',
    zIndex: 10,
    textAlign: 'left',
    width: '100%',
  },
  text: {
    color: 'white',
    fontSize: '2.4vh',
    fontWeight: 'bold',
    fontFamily: 'brhendrix',
  },
  scrollContainer: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    position: 'relative', // Changed from 'absolute' to 'relative'
    width: '100%',
    height: `135%`,
    zIndex: 2,
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  borderContainer: {
    width: '100%',
    alignItems: 'center',
    marginTop: '0',
  },
  centeredBorder: {
    marginLeft: '18%',
    width: '110%',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgba(189, 252, 251, 0.3)',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: '100%',
    backgroundColor: 'transparent', // Ensure the background is transparent
    zIndex: 10,
  },
  headerText: {
    color: 'white',
    fontSize: '2.5vh',
    fontWeight: 'bold',
    textAlign: 'center', // Center the text horizontally
    fontFamily: 'brhendrix',
  },
  listItem: {
    marginBottom: '1vh',
  },
};


export default CategoriesScreen2;
